import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App as AntApp } from 'antd';
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import App from './App';
import { ThemeProvider } from '@shared/contexts/ThemeContext';
import { I18nProvider } from '@shared/contexts/I18nContext';
import { i18n } from './lib/i18n';

dayjs.extend(localizedFormat);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <I18nProvider i18n={i18n}>
      <ThemeProvider>
        <AntApp>
          <App />
        </AntApp>
      </ThemeProvider>
    </I18nProvider>
  </StrictMode>,
);
